const quickAddWrappers = document.querySelectorAll('.quick-add-wrapper');

quickAddWrappers.forEach((wrapper) => {
  if (!wrapper) return;

  wrapper.addEventListener('click', (e) => {
    const drawer = document.querySelector('.right-drawer-vue');
    const close = drawer.querySelector('.drawer__close-btn');
    const focusTrap = window.focusTrap.createFocusTrap(drawer, {
      clickOutsideDeactivates: true,
      escapeDeactivates: true,
      initialFocus: () => close,
      onDeactivate: () => {
        drawer.classList.remove('drawer--active');
        drawer.setAttribute('aria-hidden', 'true');
      },
    });

    drawer.classList.add('drawer--active');
    drawer.setAttribute('aria-hidden', 'false');
    focusTrap.activate();

    close.addEventListener('click', () => {
      focusTrap.deactivate();
    });
  });
});
